<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <app-list-header [title]="'Preload List'" [$parent]="getSelf()">
      </app-list-header>
    </div>
    <!-- Search Form -->
    <div class="col-md-12 mt-3">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive mb-3">
                <table id="dataTableId" class="table">
                  <thead class="table-light">
                    <tr>
                      <th>S.No.</th>
                      <th>Name</th>
                      <th>Code</th>
                      <th>Status</th>
                      <th>Access</th>
                      <th>Parent</th>
                      <th>Info</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let e of form.list; let i = index">
                      <td>{{ pageIndex(i) }}</td>
                      <td>
                        <a routerLink="/preloadlistdatalist/{{ e.id }}">
                          <i class="lni lni-eye"></i> {{ e.name }}
                        </a>
                      </td>
                      <td>{{ e.code }}</td>
                      <td>{{ e.status == 1 ? "Active" : "Inactive" }}</td>
                      <td>{{ e.access == 1 ? "Yes" : "No" }}</td>
                      <td>{{ e.parentListName }}</td>

                      <td>
                        <app-info-button [ele]="e"></app-info-button>
                      </td>
                      <td>
                        <div class="d-flex order-actions">
                          <a title="Edit" data-bs-toggle="modal" data-bs-target="#editModal"
                            (click)="savePreloadList(e.id)">
                            <i class="fa fa-edit"></i>
                          </a>

                          <a title="Delete" class="ms-1" (click)="delete(e.id)">
                            <i class="fa fa-trash"></i>
                          </a>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <app-list-header [$parent]="getSelf()"></app-list-header>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- data entry form -->
<div class="modal fade" id="editModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Preload List</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="card">
          <div class="card-body p-4">
            <form #uiForm="ngForm">
              <p>
                <form-error [form]="form"></form-error>
              </p>
              <div class="row mb-3">
                <label for="name" class="col-sm-3 col-form-label">
                  Name:
                </label>
                <div class="col-sm-9">
                  <input [(ngModel)]="form.data['name']" id="name" name="name" placeholder="Enter Name" required
                    type="text" class="form-control form-control-sm" />
                </div>
              </div>

              <div class="row mb-3">
                <label for="code" class="col-sm-3 col-form-label">
                  Code:
                </label>
                <div class="col-sm-9">
                  <input [(ngModel)]="form.data['code']" id="code" name="code" placeholder="Enter Code" type="text"
                    class="form-control form-control-sm" />
                </div>
              </div>
              <div class="row mb-3">
                <label for="status" class="col-sm-3 col-form-label">
                  Status:
                </label>
                <div class="col-sm-9">
                  <select id="status" name="status" required [(ngModel)]="form.data['status']"
                    class="form-select form-select-sm">
                    <option *ngFor="let e of form.preload['statusList'] | keyvalue" [value]="e.value">
                      {{ e.key }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row mb-3">
                <label for="access" class="col-sm-3 col-form-label">Access:
                </label>
                <div class="col-sm-9">
                  <select id="access" name="access" required [(ngModel)]="form.data['access']"
                    class="form-select form-select-sm">
                    <option *ngFor="let e of form.preload['accessList'] | keyvalue" [value]="e.value">
                      {{ e.key }}
                    </option>
                  </select>
                </div>
              </div>
              &nbsp;
              <div class="row mb-3">
                <label for="parentList" class="col-sm-3 col-form-label">
                  Parent List:
                </label>
                <div class="col-sm-9">
                  <select id="parentList" name="parentList" [(ngModel)]="form['data']['parentList']"
                    class="form-select form-select-sm">
                    <option [value]="'0'">--Select--</option>
                    <option *ngFor="let e of form.preload['parentList']" [value]="e.key">
                      {{ e.value }}
                    </option>
                  </select>
                </div>
              </div>
            </form>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-outline-primary btn-sm ml-2" [disabled]="!uiForm.valid"
              (click)="save()">
              <i class="fa fa-save"></i> Save
            </button>

            <button type="button" class="btn btn-outline-secondary btn-sm ml-2" data-bs-dismiss="modal">
              <i class="fa fa-window-close"></i> Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Filter Modal -->
<div class="modal fade" id="scrollableModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Search</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" title="Close"></button>
      </div>

      <div class="modal-body">
        <div class="row mb-3">
          <label for="name" class="col-sm-3 col-form-label">Name:</label>
          <div class="col-sm-9">
            <div class="position-relative">
              <input type="text" class="form-control form-control-sm" id="name" placeholder="Enter Name"
                [(ngModel)]="form.searchParams['name']" />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <label for="code" class="col-sm-3 col-form-label">Code:</label>
          <div class="col-sm-9">
            <div class="position-relative">
              <input type="text" class="form-control form-control-sm" id="code" name="code" placeholder="Enter Code"
                [(ngModel)]="form.searchParams['code']" />
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <label for="status" class="col-sm-3 col-form-label">Status</label>
          <div class="col-sm-9">
            <select class="form-select form-select-sm" id="status" name="status"
              [(ngModel)]="form.searchParams['status']">
              <option selected>--Select--</option>
              <option *ngFor="let e of form.preload['statusList'] | keyvalue" [value]="e.value">
                {{ e.key }}
              </option>
            </select>
          </div>
        </div>

        <div class="row mb-3">
          <label for="access" class="col-sm-3 col-form-label">Access</label>
          <div class="col-sm-9">
            <select class="form-select form-select-sm" id="access" name="access"
              [(ngModel)]="form.searchParams['access']">
              <option selected>--Select--</option>
              <option *ngFor="let e of form.preload['accessList'] | keyvalue" [value]="e.value">
                {{ e.key }}
              </option>
            </select>
          </div>
        </div>

        <div class="row mb-3">
          <label for="parentList" class="col-sm-3 col-form-label">ParentList</label>
          <div class="col-sm-9">
            <select class="form-select form-select-sm" id="parentList" name="parentList"
              [(ngModel)]="form.searchParams['parentList']">
              <option selected>--Select--</option>
              <option *ngFor="let e of form.preload['parentList']" [value]="e.key">
                {{ e.value }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary btn-sm radius-30 mt-2 mt-lg-0 ms-2" title="Search"
          (click)="search()">
          Apply Filter
        </button>
        <button (click)="resetSearchForm()" class="btn btn-outline-primary btn-sm radius-30 mt-2 mt-lg-0 ms-2"
          title="Reset">
          <i class="fa fa-eraser" aria-hidden="true"></i>
        </button>
        <button type="button" title="Close" class="btn btn-outline-secondary btn-sm radius-30 mt-2 mt-lg-0 ms-2"
          data-bs-dismiss="modal">
          <i class="fa fa-window-close"></i> Close
        </button>
      </div>
    </div>
  </div>
</div>